module.exports = __webpack_public_path__ + "img/checked_bg.31deeb69.png";